module.exports = __webpack_public_path__ + "assets/ahead-b8718fff.svg";